/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightUpIcon24Solid = forwardRef('ArrowDCornerRightUpIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M22.31 8.44a1.5 1.5 0 0 1-2.12 2.12L16 6.372V16.5a4.5 4.5 0 0 1-4.5 4.5h-9a1.5 1.5 0 1 1 0-3h9a1.5 1.5 0 0 0 1.5-1.5V6.37l-4.19 4.19a1.5 1.5 0 1 1-2.12-2.122l5.503-5.503a3.263 3.263 0 0 1 4.614 0l5.504 5.503Z" })));
});
